/** @jsx h */
import { h } from 'preact'
import PoweredByProvenance from './PoweredByProvenance'
import BrandingWordmarkFlag from '../../../assets/images/svgs/branding-wordmark-flag.svg'

const TagLine = ({ onAboutClick, showPoweredByProvenanceModal, embed }) =>
  showPoweredByProvenanceModal
    ? <PoweredByProvenance onAboutClick={onAboutClick} />
    : <span class='TagLine-wordmark'><BrandingWordmarkFlag /></span>

export default TagLine
